import { useDispatch, useSelector } from "react-redux"
import { getIsUserSetCookieSettings } from "app/modules/analytics/redux/analyticsSelectors"
import { showPopup } from "app/actions/AppActions";
import { UserCookieSettings } from "app/modules/analytics/analyticsTypes";
import { getWithNewDesign } from "app/selectors/AppSelectors";
import { Button, ButtonType } from "app/ui/Button";
import CookieSettingsPopup from "app/modules/analytics/components/CookieSettingsPopup";
import { setUserCookieSettingsThunk } from "app/modules/analytics/redux/analyticsThunks";

const CookieWarningPopup = () => {
	const dispatch = useDispatch();

	const isOpen = !useSelector(getIsUserSetCookieSettings);
	const withNewDesign = useSelector(getWithNewDesign);

	if (!isOpen) return null;

	const handleSettingsClick = () => {
		dispatch(showPopup({
			popupContentNode: <CookieSettingsPopup/>,
			className: "cookie-settings-popup-mobile-wrapper",
		}))
	}

	const handleOkClick = () => {
		const data: UserCookieSettings = {
			isAnalyticsCookieAllowed: true,
			isMarketingCookieAllowed: true
		}
		dispatch(setUserCookieSettingsThunk(data));
	};

	return (
		<div className="cookie-warning-popup">
			<span>{i18n.t("CookieNotice")}</span>
			<div className="cookie-buttons-container">
				<Button classPrefix="cookie-" kind={withNewDesign ? ButtonType.STROKED : ButtonType.SECONDARY} onClick={handleSettingsClick}>{i18n.t("Configure")}</Button>
				<Button classPrefix="cookie-" kind={withNewDesign ? ButtonType.STROKED_PRIMARY : ButtonType.PRIMARY} onClick={handleOkClick}>{i18n.t("Agree")}</Button>
			</div>
		</div>
	)
}

export default CookieWarningPopup;